exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".box-container {\n    min-height: 250px;\n    width: 350px;\n    padding: 0 15px;\n}\n\n.box {\n    position: relative;\n    max-width: 350px;\n    height: 500px;\n    margin-bottom: 5%;\n    border-radius: 2px;\n    background: #ffffff;\n}\n\n.shadow {\n    box-shadow: 0 1px 7px rgba(0,0,0,0.16), 0 1px 3px rgba(0,0,0,0.23);\n    transition: all 0.3s cubic-bezier(.25,.8,.25,1);\n}\n\n.shadow:hover {\n    box-shadow: 0 1px 5px rgba(0,0,0,0.25), 0 5px 10px rgba(0,0,0,0.22);\n}\n\n.clickable {\n    cursor: pointer;\n}\n\n.invisible {\n    display: none;\n}\n\n.xx {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: block;\n}\n\n.y {\n    z-index: 100;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/partials/pagebasetile/component.css
// module id = 797
// module chunks = 0